import { useMemo } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { RootState } from "@/stores";
import { USER_ROLE_KHDN } from "@/constants/enum";

/**
 * Hook phân quyền theo role của user (KHDN: ADMIN / CHECKER / MAKER).
 *
 * Usage:
 *   const { isMaker, isChecker, isAdmin, can } = useRolePermission();
 *   {isMaker && <Button>Tạo giao dịch</Button>}
 *   {can([USER_ROLE_KHDN.MAKER, USER_ROLE_KHDN.ADMIN]) && <Button>Sửa</Button>}
 */
const useRolePermission = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const role = useMemo(() => get(user, "userRole", "") as string, [user]);

  const isAdmin = role === USER_ROLE_KHDN.ADMIN;
  const isChecker = role === USER_ROLE_KHDN.CHECKER;
  const isMaker = role === USER_ROLE_KHDN.MAKER;

  const can = (allowedRoles: string[]) =>
    allowedRoles.length === 0 || allowedRoles.includes(role);

  return {
    role,
    isAdmin,
    isChecker,
    isMaker,
    can,
  };
};

export default useRolePermission;
